export default __webpack_public_path__ + "static/media/p2023-16.8807a7f6.jpeg";